<template>
    <div class="Frame">
        <div class="SidebarMenuOpenButtton"><a @click="this.sidebarmenu($event);" style="cursor:pointer;">{{ this.risorse["CategorieProdotti"] }}</a></div>
        <div class="Bookmark"><span>{{ this.risorse["CategorieProdotti"] }}</span></div>
        <nav class="SidebarMenu">
            <ul>
                <li  v-for="catalog in this.$store.getters.getCatalogs" :key="catalog.IdCatalogo" :class="{SelectedItem : catalog.IdCatalogo == this.catalogoSelected} ">
                    <router-link @click="this.chiudiMenuCategorie($event)" :to="{name : 'CatalogProducts', params : {idCatalog : catalog.IdCatalogo}}">{{catalog.Descrizione}}</router-link>  
                    <template v-if="catalog.IdCatalogo == this.catalogoSelected">
                        <ul>
                            <li v-for="categoria in this.listaCategorie" :key="categoria.IdCategoria" :class="{SelectedItem : categoria.IdCategoria == this.categoriaSelected} ">
                                <a @click="categoriaClick(categoria.IdCategoria, $event)">{{categoria.Descrizione}}</a>
                            </li>
                        </ul>
                    </template>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
import CategoriesService from "@/services/categories.service.js";
import {modelMixin, risorseMixin} from "@/mixin.js";

export default{
    name : "CatalogSearch",
    data(){
        return {
            categoriaSelected : "",
            listaCategorie : []
        }
    },
    props: {
        catalogoSelected : String,
        categoriaExternal : String,
        modelSelected: String,
        inScheda: Boolean
    }, 
    watch:{
        catalogoSelected: function(newValue){
            this.getData();
        },
        categoriaExternal: function(newValue){
            this.categoriaSelected = newValue;
        }
    },
    methods: {
        chiudiMenuCategorie(event){
            event.preventDefault();
            $('body').removeClass('sidebarmenu');
        },
        sidebarmenu(event){
            event.preventDefault();
            if ($('body').hasClass('sidebarmenu')) {
                $('body').removeClass('sidebarmenu')
            }
            else {
                $('body').addClass('sidebarmenu')
            }	
        },
        categoriaClick: function(idCategoria, event){ 
            event.preventDefault();
            if(this.inScheda){
                this.$router.push({name: "CatalogProducts", params: {idCatalog: this.catalogoSelected, idCategoria: idCategoria}}); 
            }
            else{
                this.$emit("ListModelReady", []);
                this.categoriaSelected = idCategoria;
                this.getModels(this.$store.getters.getToken,  this.catalogoSelected, this.categoriaSelected);
            }
        },
        getData: function(){
            let token = this.$store.getters.getToken;
            CategoriesService.getCategories(token,  this.catalogoSelected).then(
                data => {
                    if(!data){
                        this.$router.push("/");
                    }
                    else{
                        this.listaCategorie = data;
                        if(this.listaCategorie.length > 0){
                            console.log(this.categoriaSelected);
                            if(!this.categoriaSelected){
                                CategoriesService.getCategoryDefault(token, this.catalogoSelected).then(
                                    (data) => {
                                        if(!data){
                                            this.$router.push("/")
                                        }
                                        else{
                                            this.categoriaSelected = data.IdCategoria;
                                            this.getModels(token,  this.catalogoSelected, this.categoriaSelected);
                                        }
                                    }
                                );
                            }
                            else{
                                this.getModels(token,  this.catalogoSelected, this.categoriaSelected);
                            }
                        }
                        else{
                            this.$emit("ListModelReady", ["no-models"]);
                        }
                    }
                }
            )
        }
    },
    mixins: [modelMixin, risorseMixin],
    mounted: function(){
        if(this.categoriaExternal){
            this.categoriaSelected = this.categoriaExternal;
        }
        this.getData();
    }
}
</script>
